import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatBadge } from '@angular/material/badge'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneSubtitleComponent,
  ElderValidationErrorDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject, Observable } from 'rxjs'
import { IdValidator } from '../../../../features/validators/id-validator'
import { ConstraintSpec } from '../../../process/capability-spec/constraints/constraint-spec'
import { ConstraintSpecTableComponent } from '../../../process/capability-spec/constraints/constraint-spec-table/constraint-spec-table.component'
import { PropertyKind } from '../../property'
import { PropertySpec } from '../../spec/property-spec'
import { PropertySpecTableComponent } from '../../spec/property-spec-table/property-spec-table.component'
import { DynamicPropertySpec } from '../dynamic-property-spec'

@Component({
  selector: 'app-dynamic-property-spec-detail',
  templateUrl: './dynamic-property-spec-detail.component.html',
  styleUrls: ['./dynamic-property-spec-detail.component.scss'],
  imports: [
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderPaneContentComponent,
    ElderPaneSubtitleComponent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatError,
    ElderValidationErrorDirective,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatBadge,
    ConstraintSpecTableComponent,
    PropertySpecTableComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class DynamicPropertySpecDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _spec$ = new BehaviorSubject<DynamicPropertySpec>(null)

  public readonly idValidatorPattern = IdValidator.pattern

  @Input()
  public propertyKinds: PropertyKind[]

  @Output()
  public specChange: EventEmitter<DynamicPropertySpec> = new EventEmitter<DynamicPropertySpec>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get spec$(): Observable<DynamicPropertySpec> {
    return this._spec$.asObservable()
  }

  public get spec(): DynamicPropertySpec {
    return this._spec$.getValue()
  }

  @Input()
  public set spec(spec: DynamicPropertySpec) {
    this._spec$.next(spec)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onConditionChanged(specs: ConstraintSpec[]): void {
    this.spec.conditions = specs
    this.specChange.emit(this.spec)
  }

  public onPropertiesChanged(specs: PropertySpec[]): void {
    this.spec.properties = specs
    this.specChange.emit(this.spec)
  }
}
